import { ClassroomDisplay } from "./ClassroomDisplay";

export function DisplayPage() {
  const sessionId = decodeURIComponent(window.location.pathname.split("/")[2] || "");
  return <ClassroomDisplay sessionId={sessionId} />;
}
